const BATCH_COMPLETE_STATUS_ID = 3;
const BATCH_GENERATING_STATUS_ID = 2;

class BatchStatusIdServiceClass {
  isGenerating(statusId) {
    return statusId === BATCH_GENERATING_STATUS_ID;
  }

  isProcessing(statusId) {
    return statusId < BATCH_COMPLETE_STATUS_ID;
  }
}

export const BatchStatusIdService = new BatchStatusIdServiceClass();
